import { FioSuggestions } from '@pulse-web-ui/dadata';

import { InstanceUrls, RequestMethods, useQueryFunction } from '@src/shared';

import type { DadataFioSuggestionsProps } from './dadata-fio-suggestions.types';

export const DadataFioSuggestions = (props: DadataFioSuggestionsProps) => {
  const queryFn = useQueryFunction(
    {
      method: RequestMethods.POST,
      url: 'api/v3/dadata/suggest/fio',
    },
    InstanceUrls.DADATA_URL
  );

  return (
    <FioSuggestions
      isCapitalizeFirst
      delay={250}
      minChars={1}
      customRequest={queryFn}
      {...props}
    />
  );
};
